import { CustomForm } from 'components/form/customForm'
import { FormField } from 'components/form/customFormField'
import { useOrganizationForm, UseOrganizationFormProps } from 'hooks/admin/useOrganizations'
import React from 'react'

interface OrganizationFormProps extends UseOrganizationFormProps {}

export const OrganizationForm: React.FC<OrganizationFormProps> = ({ initialData, onClose, queryKey = ['organizations'] }) => {
    const { control, handleSubmit, errors, loading } = useOrganizationForm({ initialData, queryKey, onClose })

    return (
        <CustomForm handleSubmit={handleSubmit} loading={loading} initialData={initialData} onClose={onClose}>
            <FormField
                name="email"
                control={control}
                errors={errors}
                label="Szervezet email címe"
                placeholder="Email"
                rules={{
                    required: 'Az email cím megadása kötelező.',
                    pattern: 'Kérjük érvényes email címet adjon meg.',
                }}
                readOnly={!!initialData}
            />
            <FormField
                name="organizationName"
                control={control}
                errors={errors}
                label="Szervezet megnevezése"
                placeholder="Név"
                rules={{
                    required: 'A szervezet neve megadása kötelező.',
                }}
            />
            <FormField
                name="contactInfo"
                control={control}
                errors={errors}
                label="Egyéb elérhetőség"
                placeholder="Elérhetőség"
                rules={{
                    required: 'Az elérhetőség megadása kötelező.',
                }}
            />
        </CustomForm>
    )
}
